<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <side-bar></side-bar>
  </div>
</template>

<script>
import "assets/js/flexible.js";
import "assets/js/iconfont.js";
import SideBar from "components/common/sidebar/SideBar.vue";
export default {
  name: "App",
  components: {
    SideBar,
  },
  created() {
    let suggestTheme =
      new Date().getHours() >= 18 ? "dark-theme" : "light-theme";
    document.querySelector("body").className = suggestTheme;

    let theme = localStorage.getItem("theme")
      ? localStorage.getItem("theme")
      : suggestTheme;
    document.querySelector("body").className = theme;
    localStorage.setItem("theme", theme);
  },
};
</script>

<style lang="less">
@import "./assets/css/base.less";
</style>
